import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from './useDeleteModal';

interface IDeleteModal {
  openModal: boolean;
  dataToDelete: { id: string | undefined };
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: IDeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <CommonDeleteModal
      onCancel={onDeleteModalClose}
      open={openModal}
      isLoading={isLoading}
      onOk={() => onRemoveConfirm(dataToDelete)}
      onClose={onDeleteModalClose}
      title={'Delete Shipping Rate'}
      message={'Are you sure you want to delete the Shipping rate?'}
    />
  );
};
